import {
  ActivityProgressFilterParams,
  getActivityProgress,
  listActivityProgress,
} from '@/data/services/activityProgressServices';

export const activityProgressQueries = {
  all: ['activitiesProgresses'] as const,

  get: (id: number) => ({
    queryKey: [...activityProgressQueries.all, 'get', id] as const,
    queryFn: () => getActivityProgress(id),
  }),

  list: (filters: ActivityProgressFilterParams = {}) => ({
    queryKey: [...activityProgressQueries.all, 'list', { filters }] as const,
    queryFn: () => listActivityProgress(filters),
  }),
};
